// ===================================================================
// PHOENIX OS — SERVIÇO DE MIGRAÇÃO DE CONTA (lado do app)
// ===================================================================
// Mesmo padrão do asaasService.js: só CHAMA a Cloud Function, nunca
// mexe direto no Firestore de outra conta (isso é bloqueado por regra
// de segurança de propósito — só a Cloud Function, rodando com
// privilégio de admin, pode reatribuir dados entre UIDs diferentes).
// Vai em src/services/migrarContaService.js
// ===================================================================

import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from './firebase';

const functions = getFunctions(app, 'southamerica-east1');

export async function migrarSessaoAnonima({ uidAntigo }) {
    const chamar = httpsCallable(functions, 'migrarSessaoAnonima');
    const resultado = await chamar({ uidAntigo });
    return resultado.data; // { migrado, dossiesMigrados }
}